module.exports = __webpack_public_path__ + "static/media/boat-img-4.520397f4.jpg";